import React,{useState} from 'react';
// comps
import LeadPart from '../comps/leaderpart'
import Headerphoto from '../comps/headerphoto'
import {Helmet} from "react-helmet";

const VistedLead = props => {
  const[isType,setType] = useState('h');
  return(
    <section className="FollowPage">
  <Helmet>
    <title>Followers</title>
       <meta name="theme-color" content="#0f0f0f" />
  <meta name="description" content='watch the people that you follow now'/>
<meta name='keywords' content='friends,following,following page'/>
 <link rel="canonical" href="https://pinweelo.com/following" />
    </Helmet>
{/*<Headerphoto name={'d'} img={'d'}/>*/}
<LeadPart page={true} />

  </section>
  )
}
export default VistedLead;
